import store from '../store/store';
import { traceAttachmentModelRetrieved } from '../utils/attachmentModelLifeTimeTracer';
import { select } from 'satcheljs/lib/legacy';
export default select({
    store: function () { return store; },
})(function getAttachment(attachmentId, state) {
    var attachment = state.store.attachments.get(attachmentId.Id);
    // TODO: VSO #23684 Remove when issue is investigated
    traceAttachmentModelRetrieved(attachmentId.Id);
    return attachment;
});
//# sourceMappingURL=getAttachment.js.map